// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a87dbfb0","455":"209c78c5","977":"f504427e"}[chunkId] + ".chunk.js";
};